import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authApi } from "features/auth/api"
import thunk from "redux-thunk";
import appReducer from "./appSlice";
import bookingReducer from "./bookingSlice"
import parentApi from "./parentApi"

const reducers = combineReducers({
  [appReducer.name]: appReducer.reducer,
  [bookingReducer.name]: bookingReducer.reducer,
  [parentApi.reducerPath]: parentApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  appState: appReducer,
  bookingState: bookingReducer,
})

export default configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat(
      authApi.middleware,
      parentApi.middleware,
      thunk
    ),
});
